import { render, staticRenderFns } from "./topSeries.vue?vue&type=template&id=559484e2&"
import script from "./topSeries.vue?vue&type=script&lang=js&"
export * from "./topSeries.vue?vue&type=script&lang=js&"
import style0 from "./topSeries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "topSeries.vue"
export default component.exports